import React from 'react';

const microbeData = [
  { name: 'M1', strength: 6, agility: 4, intelligence: 9, trait: 'Air' },
  { name: 'M2', strength: 7, agility: 5, intelligence: 10, trait: 'Earth' },
  { name: 'M3', strength: 8, agility: 6, intelligence: 8, trait: 'Fire' },
  { name: 'M4', strength: 5, agility: 3, intelligence: 7, trait: 'Earth' },
  { name: 'M5', strength: 4, agility: 7, intelligence: 5, trait: 'Water' },
  { name: 'M6', strength: 9, agility: 2, intelligence: 6, trait: 'Fire' },
  { name: 'M7', strength: 6, agility: 6, intelligence: 7, trait: 'Air' },
  { name: 'M8', strength: 10, agility: 1, intelligence: 9, trait: 'Water' },
  { name: 'M9', strength: 5, agility: 4, intelligence: 7, trait: 'Fire' },
  { name: 'M10', strength: 7, agility: 3, intelligence: 8, trait: 'Earth' },
];

const traitColors = {
  Air: '#60A5FA', // blue
  Earth: '#A3E635', // green
  Fire: '#F87171', // red
  Water: '#38BDF8', // cyan
};

const traitIcons = {
  Air: '🌬️',
  Earth: '🌱',
  Fire: '🔥',
  Water: '💧',
};

const attrIcons = {
  strength: '💪',
  agility: '🤸',
  intelligence: '🧠',
};

function MicrobeCard({ name, strength, agility, intelligence, trait }) {
  return (
    <div className="microbe-card flex flex-col items-center rounded-2xl bg-white shadow-md p-4 w-full sm:w-[calc(100%-16px)] md:w-48 min-h-[320px] border border-gray-100 relative">
      {/* Image placeholder */}
      <div className="w-16 h-16 rounded-full flex items-center justify-center mb-2 mt-2" style={{ background: traitColors[trait] + '22' }}>
        <span style={{ fontSize: 36 }}>{traitIcons[trait]}</span>
      </div>
      <div className="font-semibold text-lg text-gray-800 mb-2 text-center">{name}</div>
      <div className="text-xs text-gray-400 mb-1">Attributes</div>
      <div className="flex flex-col gap-2 w-full mb-3">
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.strength}</span>Strength</span>
          <span className="font-bold text-gray-800">{strength}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.agility}</span>Agility</span>
          <span className="font-bold text-gray-800">{agility}</span>
        </div>
        <div className="flex items-center justify-between w-full px-2">
          <span className="flex items-center gap-1 text-gray-600"><span>{attrIcons.intelligence}</span>Intelligence</span>
          <span className="font-bold text-gray-800">{intelligence}</span>
        </div>
      </div>
      <div className="text-xs text-gray-400 mb-1">Trait</div>
      <div className="flex items-center gap-2 mt-1">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded bg-white border" style={{ background: traitColors[trait], color: '#fff' }}>{traitIcons[trait]}</span>
        <span className="text-sm font-medium text-gray-700">{trait}</span>
      </div>
    </div>
  );
}

export default function MicrobeCardsGrid() {
  return (
    <div className="w-full flex flex-wrap gap-4 md:gap-6 justify-center">
      {microbeData.map((microbe, idx) => (
        <MicrobeCard key={microbe.name + idx} {...microbe} />
      ))}
    </div>
  );
} 